import { Controller } from '@hotwired/stimulus';

// Les liens ne reçoivent leur URL de vote qu'ici : écrite dans le HTML, un
// robot la suivrait en GET, alors que la route n'accepte que PUT.
export default class FAQVoteController extends Controller<HTMLElement> {
  static targets = ['upvote', 'downvote', 'votes', 'thanks'];

  static values = { upvoteUrl: String, downvoteUrl: String };

  declare readonly upvoteTarget: HTMLAnchorElement;

  declare readonly downvoteTarget: HTMLAnchorElement;

  declare readonly votesTarget: HTMLElement;

  declare readonly thanksTarget: HTMLElement;

  declare readonly upvoteUrlValue: string;

  declare readonly downvoteUrlValue: string;

  connect(): void {
    this.upvoteTarget.href = this.upvoteUrlValue;
    this.downvoteTarget.href = this.downvoteUrlValue;
  }

  thank(): void {
    this.votesTarget.remove();
    this.thanksTarget.hidden = false;
  }
}
